import React from 'react';
import { css } from 'react-emotion';
import { flex } from 'appStyles';

const slash = css`
position: absolute;
  width: 100%;
  height: 2px;
  background: rgba(70,70,70,1);
`;

const box = css`
  ${flex};
  width: 1rem;
  height: 1rem;
  transform-origin: center;
  position: relative;
  cursor: pointer;
`;

const forwardSlash = css`
  ${slash};
  transform: rotate(45deg);
`;

const backSlack = css`
  ${slash};
  transform: rotate(-45deg);
`;

const X = (props) => (
  <div
    className={box}
    onClick={props.onClick}
    style={{
      width: `${props.size || 1}rem`,
      height: `${props.size || 1}rem`,
      ...props.style
     }}
  >
    <div className={forwardSlash} style={{ background: props.color}} />
    <div className={backSlack} style={{ background: props.color }}/>
  </div>
);

export default X;
